/** Export/import file formats supported by the API. */
export enum DataFormat {
  Json = "json",
  Yaml = "yaml",
  Csv = "csv",
}

/** How imported data is merged with existing records. */
export enum ImportMode {
  Merge = "merge",
  Replace = "replace",
}

export const DATA_FORMAT_OPTIONS: { value: DataFormat; label: string }[] = [
  { value: DataFormat.Json, label: "JSON" },
  { value: DataFormat.Yaml, label: "YAML" },
  { value: DataFormat.Csv, label: "CSV" },
];

export const DATA_FORMAT_FILE_EXTENSIONS: Record<DataFormat, string[]> = {
  [DataFormat.Json]: [".json"],
  [DataFormat.Yaml]: [".yaml", ".yml"],
  [DataFormat.Csv]: [".csv"],
};

export const MEMBERSHIP_EXPORT_FILENAME_PREFIX = "membership-export-";
